import { get, union } from 'lodash/fp';
import {
  getCustomerBookings,
  getBooking,
  updateBooking,
  cancelBooking,
  clearBookings,
  SAVE_BOOKING_ACTION_TYPE,
  filterCustomerBookings,
} from '../actions/bookings';
import { IBooking } from '../helpers/types';

interface IState {
  data: {
    [locale: string]: {
      all: string[];
      bookings?: Record<string, IBooking>;
      next: any;
    };
  };
  loading: boolean;
  error: null | Error;
  filtered: boolean;
  filtering: boolean;
}

const initialState: IState = {
  data: {},
  loading: false,
  error: null,
  filtered: false,
  filtering: false,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case clearBookings.TRIGGER:
      return { ...initialState };

    case getBooking.REQUEST:
    case updateBooking.REQUEST:
    case cancelBooking.REQUEST:
    case getCustomerBookings.REQUEST:
      return { ...state, loading: true, error: null, filtered: false };

    case filterCustomerBookings.REQUEST:
      return { ...state, filtering: true, error: null, filtered: false, data: {} };

    case getCustomerBookings.SUCCESS: {
      const { locale, bookings, all, next } = action.payload;
      const prevBookings = get(`data.${locale}.bookings`, state);
      const prevAll = get(`data.${locale}.all`, state);

      return {
        ...state,
        data: {
          ...state.data,
          [locale]: {
            bookings: { ...prevBookings, ...bookings },
            all: union(all, prevAll),
            next,
          },
        },
      };
    }

    case filterCustomerBookings.SUCCESS: {
      const { locale, bookings, all, next } = action.payload;

      return {
        ...state,
        filtered: true,
        data: {
          ...state.data,
          [locale]: {
            bookings,
            all,
            next,
          },
        },
      };
    }

    case SAVE_BOOKING_ACTION_TYPE:
    case getBooking.SUCCESS:
    case updateBooking.SUCCESS:
    case cancelBooking.SUCCESS: {
      const { locale, id, booking } = action.payload;
      const prevBookings = get(`data.${locale}.bookings`, state);

      return {
        ...state,
        data: {
          ...state.data,
          [locale]: {
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            ...state.data[locale],
            bookings: { ...prevBookings, [id]: booking },
          },
        },
      };
    }

    case getCustomerBookings.FAILURE:
    case getBooking.FAILURE:
    case updateBooking.FAILURE:
    case cancelBooking.FAILURE:
    case filterCustomerBookings.FAILURE:
      return { ...state, error: action.payload };

    case getCustomerBookings.FULFILL:
    case getBooking.FULFILL:
    case updateBooking.FULFILL:
    case cancelBooking.FULFILL:
      return { ...state, loading: false };

    case filterCustomerBookings.FULFILL:
      return { ...state, filtering: false };

    default:
      return state;
  }
};
